export const PUBLIC_HOLIDAY_WEEKDAY_CONST = 10
